import { SimulationParameterType, type SimulationParameterView } from '@nexelem/graphne-api';
import z from 'zod';
import { parseParameterDefaultValue } from './groupSimulationParameters';

export const getParametersSchema = (parameters: SimulationParameterView[]) =>
  parameters.reduce((acc, param) => {
    const key = param.id.toString();

    if (param.parameterType === SimulationParameterType.Boolean) {
      return acc.extend({
        [key]: z.enum(['true', 'false']),
      });
    }

    if (param.parameterType === SimulationParameterType.Int) {
      const numberSchema = z.coerce.number();

      return acc.extend({
        [key]: param.isOptional ? numberSchema.optional() : numberSchema,
      });
    }

    if (param.parameterType === SimulationParameterType.Date) {
      return acc.extend({
        [key]: param.isOptional ? z.date().optional() : z.date(),
      });
    }

    return acc.extend({
      [key]: param.isOptional ? z.string().optional() : z.string(),
    });
  }, z.object({}));

export const getParametersDefaultValues = (parameters: SimulationParameterView[]) =>
  parameters.reduce(
    (acc, param) => {
      acc[param.id.toString()] = parseParameterDefaultValue(param);
      return acc;
    },
    {} as Record<string, unknown>,
  );
